import React from 'react';
import CheckOrCross from '../Shared/CheckOrCross';

const communityVoiceLibraryFeatures = ({ packages }) =>
  packages.map((pkg) => <CheckOrCross key={pkg?.code} isCheck />);

export default communityVoiceLibraryFeatures;
